import { FC, useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { WalkThrough } from 'components/features/WalkThrough';

import styles from './Plays.module.scss';
export const Plays: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const redirect = queryParams.get('redirect') || false;
  usePageTitle(`楽しみ方ガイド`);

  const handleClose = useCallback(async () => {
    if (redirect) {
      navigate(`/${redirect}`);
      return;
    }
    navigate('/home');
  }, [navigate, redirect]);

  return (
    <>
      <div className={styles.page}>
        <WalkThrough handleClose={handleClose} />
      </div>
    </>
  );
};
